import React, { useEffect, useState } from 'react';
import { Button, List, Tag, Space, message, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { feesApi, EntityKey } from '../../services/api/feesApi';

export interface FeesEditorProps { entityType: EntityKey; entityId: number; editable?: boolean; }

const FeesEditor: React.FC<FeesEditorProps> = ({ entityType, entityId, editable }) => {
  const [fees, setFees] = useState<any[]>([]);
  const [templates, setTemplates] = useState<any[]>([]);

  const load = async () => setFees(await feesApi.list(entityType, entityId));
  useEffect(() => { load(); }, [entityType, entityId]);
  useEffect(() => { if (editable) feesApi.listTemplates().then(setTemplates); }, [editable]);

  const addFromTemplate = async (t: any) => {
    try {
      await feesApi.add(entityType, entityId, {
        fee_type: t.fee_type, label: t.label,
        calculation_method: t.calculation_method, value: t.value,
        cap: t.cap, is_taxable: t.is_taxable,
      });
      await load();
    } catch (e: any) { message.error(`Add failed: ${e.message}`); }
  };

  const remove = async (id: number) => {
    try { await feesApi.remove(entityType, entityId, id); await load(); }
    catch (e: any) { message.error(`Delete failed: ${e.message}`); }
  };

  return (
    <div>
      {/* Only render the list when there are fees — an empty <List> shows Ant Design's
          large "No data" illustration, which ballooned the estimate footer and squished
          the items table. No fees = render nothing here. */}
      {fees.length > 0 && (
        <List size="small" dataSource={fees} renderItem={(f) => (
          <List.Item actions={editable ? [
            <Popconfirm title="Delete fee?" onConfirm={() => remove(f.id)} key="del">
              <Button size="small" danger icon={<DeleteOutlined />} />
            </Popconfirm>
          ] : []}>
            <Space>
              <Tag>{f.fee_type}</Tag>
              <span>{f.label}</span>
              <span>{f.calculation_method === 'flat' ? `$${f.value.toFixed(2)}` : `${f.value}%`}</span>
              {!f.is_taxable && <Tag color="orange">non-tax</Tag>}
            </Space>
          </List.Item>
        )} />
      )}
      {editable && templates.length > 0 && (
        <Space wrap style={{ marginTop: 8 }}>
          {templates.map((t) => (
            <Button key={t.id} size="small" onClick={() => addFromTemplate(t)}>+ {t.label}</Button>
          ))}
        </Space>
      )}
    </div>
  );
};
export default FeesEditor;
